<template lang="pug">
  - $image_path = '@/assets/images/game/results/';
  .view-results(ref="page")
    .page-title
      p.page-title-text(ref="title"): img(src=`${$image_path}title.png`)
      .page-title-decoration-white(ref="titleDecoration")
        img(src=`${$image_path}title_decoration_white.png`)
      .page-title-decoration-yellow(ref="titleDecoration")
        img(src=`${$image_path}title_decoration_yellow.png`)
    .frame
        .score
          .score-item.score-happy-turn
            .score-icon(ref="iconHappyturn"): img(src=`${$image_path}image_happy_turn.png`)
            .score-numbers
              p.score-number.number-sprite-m(
                v-for="num in scoreList"
                :class="`number-${num}`"
              )
          .score-item.score-life
            .score-icons
              .score-icon(v-for="num of 3")
                .score-icon-active(ref="iconHeart"): img(src=`${$image_path}image_heart_on.png`)
                img(src=`${$image_path}image_heart_off.png`)
            .score-numbers
              p.score-number.number-sprite-m.number-plus
              p.score-number.number-sprite-m(
                v-for="num in lifeScoreList"
                :class="`number-${num}`"
              )
          .score-item.score-total
            .score-icon(ref="iconTotal"): img(src=`${$image_path}text_total.png`)
            .score-numbers
              p.score-number.number-sprite-l(
                v-for="num in totalScoreList"
                :class="`number-${num}`"
              )
    .text(ref="text")
      img(v-if="isHighScore" src=`${$image_path}text_highscore.png`)
      img(v-else src=`${$image_path}text.png`)
    .charactor(ref="charactor"): img(src=`${$image_path}image_charactor.png`)
    .retry(ref="retry")
      button(@click="playSound('se_click_button'); $emit('onRetry');")
        img(src=`${$image_path}button_retry.png`)
    .top(ref="top")
      router-link(:to="{ name:'top' }" @click.native="playSound('se_click_button')")
        img(src=`${$image_path}button_top.png`)
    .debug-buttons
      button(@click="debugScore(299)") とっターン賞
      button(@click="debugScore(599)") やっターン賞
      button(@click="debugScore(699)") 超ハッピーターン賞（銅）
      button(@click="debugScore(799)") 超ハッピーターン賞（銀）
      button(@click="debugScore(800)") 超ハッピーターン賞（金）
</template>

<script>
import { TimelineMax, TweenMax } from 'gsap';
import _ from 'lodash';
import { mapGetters, mapState } from 'vuex';

import CountUp from '@/assets/js/CountUp';
import SoundController from '@/assets/js/SoundController';
import Utils from '@/assets/js/Utils';

export default {
  name: 'Results',
  props: {
    isHighScore: {
      type: Boolean,
      default: null
    }
  },
  data() {
    return {
      data: null,
      totalScoreCounter: null,
      lifeScoreCounter: null,
      scoreCounter: null,
      scoreList: [0],
      lifeScoreList: [0],
      totalScoreList: [0]
    };
  },
  computed: {
    ...mapGetters(['totalScore', 'lifeScore']),
    ...mapState(['score', 'life'])
  },
  beforeDestroy() {
    if (this.totalScoreCounter) this.totalScoreCounter.stop();
    if (this.lifeScoreCounter) this.lifeScoreCounter.stop();
    if (this.scoreCounter) this.scoreCounter.stop();
  },
  mounted() {
    SoundController.stopAll();
    SoundController.play('jingle_result');

    Utils.addTimer({ key: 'resultCountUp', time: 1000 }, this.countup);
    this.startTimelineAnimation();
  },
  methods: {
    countup() {
      const totalScoreCountUp = () => {
        SoundController.play('se_show_result_value');
        this.totalScoreCounter = new CountUp(
          this.totalScore,
          count => {
            SoundController.play('se_add_score');
            this.totalScoreList = Utils.getNumberToList(count);
          },
          () => {
            SoundController.play('se_show_total_score');
          }
        );
      };

      const lifeScoreCountUp = () => {
        SoundController.play('se_show_result_value');
        this.lifeScoreCounter = new CountUp(
          this.lifeScore,
          count => {
            SoundController.play('se_add_score');
            this.lifeScoreList = Utils.getNumberToList(count);
          },
          totalScoreCountUp
        );
      };

      this.scoreCounter = new CountUp(
        this.score,
        count => {
          SoundController.play('se_add_score');
          this.scoreList = Utils.getNumberToList(count);
        },
        lifeScoreCountUp
      );
    },
    startTimelineAnimation() {
      const timeline = new TimelineMax();
      const zoom = (target, duration, animationTimeline) => {
        const halfDuration = duration * 0.5;
        animationTimeline
          .fromTo(
            target,
            halfDuration,
            { opacity: 0, transform: 'scale(0)' },
            { opacity: 0.5, transform: 'scale(1.5)' }
          )
          .to(target, halfDuration, { opacity: 1, transform: 'scale(1)' });
      };
      TweenMax.fromTo(
        this.$refs.iconHappyturn,
        0.5,
        { opacity: 0, transform: 'scale(0)' },
        { opacity: 1, transform: 'scale(1)' }
      );

      zoom(this.$refs.title, 0.5, timeline);
      timeline.fromTo(
        this.$refs.titleDecoration,
        0.5,
        { opacity: 0 },
        { opacity: 1 }
      );

      _.forEach(this.$refs.iconHeart, (target, index) => {
        if (index <= this.life - 1) zoom(target, 0.5, timeline);
      });
      zoom(this.$refs.iconTotal, 0.5, timeline);

      const charactorX = this.$refs.charactor.clientWidth * 0.5;
      const charactorY = this.$refs.charactor.clientWidth * 0.2;
      timeline.fromTo(
        this.$refs.charactor,
        0.5,
        { x: charactorX, y: charactorY, opacity: 0 },
        { x: 0, y: 0, opacity: 1 }
      );
      timeline.fromTo(
        this.$refs.text,
        0.5,
        { y: 30, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          onComplete: () => {
            if (this.isHighScore) SoundController.play('se_show_highscore');
          }
        }
      );
      timeline.fromTo(
        this.$refs.retry,
        0.5,
        { y: 30, opacity: 0 },
        { y: 0, opacity: 1 }
      );
      timeline.fromTo(
        this.$refs.top,
        0.5,
        { y: 30, opacity: 0 },
        { y: 0, opacity: 1 }
      );
    },
    playSound(key) {
      SoundController.play(key);
    },
    debugScore(number) {
      this.$emit('debugScore', number);
      this.scoreList = Utils.getNumberToList(this.score);
      this.lifeScoreList = Utils.getNumberToList(this.lifeScore);
      this.totalScoreList = Utils.getNumberToList(this.totalScore);
    }
  }
};
</script>

<style scoped lang="scss">
.view-results {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  min-height: vw(2140);
  background: image-url('game/results/bg.png') no-repeat #f8ac13;
  background-size: 100% auto;
  &::before {
    display: block;
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: image-url('game/results/bg_pattern.png');
    background-size: vw(400) vw(436);
  }
  .page-title {
    top: vw(108);
    left: vw(228.5);
    z-index: 1;
    &-text {
      width: vw(823);
    }
    &-decoration {
      &-white {
        top: vw(-42);
        left: vw(8);
        width: vw(807);
      }
      &-yellow {
        top: vw(-62);
        left: vw(-50);
        width: vw(947);
      }
    }
  }
  .frame {
    position: absolute;
    top: vw(329);
    left: vw(41);
    width: vw(1198);
    height: vw(848);
    background-image: image-url('game/results/image_frame.png');
    background-size: contain;
    z-index: 0;
  }
  .score {
    position: absolute;
    top: vw(95);
    left: vw(135);
    width: vw(937);
    z-index: 1;
    &-number {
      margin-left: vw(-18);
      &:first-child {
        margin-left: 0;
      }
    }
    &-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    &-icons {
      display: flex;
      .score-icon {
        margin-right: vw(12);
      }
    }
    &-numbers {
      display: flex;
      justify-content: flex-end;
      align-items: flex-end;
      width: 100%;
    }
    &-happy-turn {
      position: relative;
      margin-bottom: vw(40);
      .score-icon {
        position: absolute;
        top: vw(-20);
        width: vw(160);
      }
    }
    &-life {
      position: relative;
      margin-bottom: vw(100);
      .score-icons {
        position: absolute;
      }
      .score-icon {
        position: relative;
        width: vw(130);
        &-active {
          position: absolute;
          top: 0;
          left: 0;
          width: vw(142);
          opacity: 0;
        }
      }
    }
    &-total {
      position: relative;
      align-items: flex-end;
      .score-icon {
        position: absolute;
        top: vw(75);
        width: vw(194);
      }
    }
  }
  .charactor {
    position: absolute;
    top: vw(1145);
    left: vw(-106);
    width: vw(540);
  }
  .text {
    position: absolute;
    top: vw(1090);
    left: vw(152);
    width: vw(1182);
  }
  .retry {
    position: absolute;
    top: vw(1686);
    left: vw(232);
    width: vw(816);
  }
  .top {
    position: absolute;
    top: vw(1898);
    left: vw(232);
    width: vw(816);
    a {
      display: block;
    }
  }
  .debug-buttons {
    position: absolute;
    top: vw(30);
    left: vw(30);
    z-index: 1;
  }
  .number-sprite-m {
    background-image: image-url('game/number_m_spritesheet.png');
  }
  .number-sprite-l {
    background-image: image-url('game/number_l_spritesheet.png');
  }
}
</style>
